import { render, staticRenderFns } from "./ApplicationsTable.vue?vue&type=template&id=2b08599d&scoped=true"
import script from "./ApplicationsTable.vue?vue&type=script&lang=ts"
export * from "./ApplicationsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b08599d",
  null
  
)

export default component.exports